import React from 'react'
import"./AboutPhase1.css"
const AboutPhase1 = () => {
  return (
    <div className='aboutphase1'>
        <div className="parabox">
        <p className="about">About</p>
        <p className="paraabout">Hi, I'm William Kinyua</p>
        </div>
    </div>
  )
}

export default AboutPhase1